/**
 * 查询键
 */
export const QUERY_KEYS = {
  VIP_SUPPID_LIST: 'vipSuppIdList',
  VIP_SUPPID_STATS: 'vipSuppIdStats',
} as const;

/**
 * 抽屉配置
 */
export const DRAWER_CONFIG = {
  WIDTH: 600,
  PLACEMENT: 'right' as const,
} as const;

/**
 * 表单默认值
 */
export const FORM_DEFAULT_VALUES = {
  beautifulNumber: '',
} as const;

